module.exports = __webpack_public_path__ + "img/Wallet.224b9057.svg";